import { render, staticRenderFns } from "./MatchScore.vue?vue&type=template&id=142df11a&lang=pug"
import script from "./MatchScore.vue?vue&type=script&lang=js"
export * from "./MatchScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports